import styled from 'styled-components'

export const HeaderWrapper = styled.header`
  padding: 20px 40px;
  position: relative;
  background: white;
`

export const Nav = styled.nav`
  display: flex;
  justify-content: space-between;
  align-items: center;
  max-width: 1200px;
  margin: 0 auto;
`

export const NavLeft = styled.div`
  display: flex;
  align-items: center;
  gap: 24px;
`

export const Logo = styled.div`
  display: flex;
  align-items: center;
`

export const LogoCircle = styled.img`
  width: 32px;
  height: 32px;
  object-fit: contain;
`

export const LanguageSelector = styled.div`
  select {
    padding: 8px 16px;
    border: none;
    background: transparent;
    font-size: 16px;
    cursor: pointer;
    color: #000;
    font-weight: 500;
    appearance: none;
    -webkit-appearance: none;
    background-image: url("data:image/svg+xml,%3Csvg width='10' height='6' viewBox='0 0 10 6' fill='none' xmlns='http://www.w3.org/2000/svg'%3E%3Cpath d='M1 1L5 5L9 1' stroke='black' stroke-width='1.5' stroke-linecap='round' stroke-linejoin='round'/%3E%3C/svg%3E");
    background-repeat: no-repeat;
    background-position: right 0 center;
    padding-right: 20px;

    &:focus {
      outline: none;
    }
  }
`

export const NavRight = styled.div`
  display: flex;
  align-items: center;
  gap: 24px;
`

export const PricingLink = styled.a`
  text-decoration: none;
  color: #000;
  font-size: 16px;
  font-weight: 500;
  cursor: pointer;
  transition: all 0.2s ease;
  &:hover {
    color: #40a9ff;
  }
`

export const LoginButton = styled.button`
  padding: 8px 24px;
  border: 1px solid rgba(0, 0, 0, 0.1);
  border-radius: 100px;
  background: white;
  cursor: pointer;
  font-size: 16px;
  color: #000;
  font-weight: 500;
  transition: all 0.2s ease;

  &:hover {
    background: rgba(0, 0, 0, 0.02);
  }
`

export const ChromeButton = styled.a`
  display: flex;
  align-items: center;
  gap: 8px;
  padding: 8px 16px;
  border: none;
  border-radius: 100px;
  background: #18181b;
  color: white;
  cursor: pointer;
  font-size: 16px;
  font-weight: 500;
  text-decoration: none;
  transition: all 0.2s ease;

  &:hover {
    background: #000;
  }

  img {
    width: 16px;
    height: 16px;
    filter: brightness(0) invert(1);
  }
`

export const UserInfo = styled.div`
  display: flex;
  align-items: center;
  gap: 16px;
`
